import gql from 'graphql-tag';

import { useQuery } from '@apollo/react-hooks';

import { invoicePreviewQuery as InvoicePreviewQueryData } from './types/invoicePreviewQuery';

type Input = {
  accountId: number;
  planId: string | number | null | undefined;
};

export const invoicePreviewQuery = gql`
  query invoicePreviewQuery($accountId: Int!, $planId: ID) {
    account(id: $accountId) {
      id
      invoicePreview(planId: $planId) {
        amountDue
        id
        items {
          amount
          description
          id
        }
        periodEnd
        startingBalance
        total
      }
    }
  }
`;

export const useInvoicePreview = ({ accountId, planId }: Input) => {
  const queryResults = useQuery<InvoicePreviewQueryData>(invoicePreviewQuery, {
    skip: !accountId || !planId,
    variables: {
      accountId,
      planId,
    },
  });

  return {
    error: queryResults.error
      ? 'There was an issue loading your invoice preview. Please try again'
      : null,
    invoice: queryResults?.data?.account?.invoicePreview,
    isLoading: queryResults.loading,
  };
};
